module.exports = __webpack_public_path__ + "media/customizations/windler/back-5cefce2be85c51458b8ef21aba71b7c6.jpg";